import React from "react";
import styled from "styled-components";
import { POLICIES, DOCUMENT_LINKS } from "./constants";

const StyledWrapper = styled.div`
  font-size: small;
  cursor: pointer;
  margin-top: 0.5rem;
  display: inline-grid;

  .hover-color:hover {
    color: var(--orange);
  }

  @media (max-width: 992px) {
    text-align: ${(props) => props.textAlignVal};
  }

  .hover-color {
    padding: 0.3rem 0;
  }
`;

const PolicyAndCharter = (props) => {
  const { textAlignVal = "center" } = props;

  const PoliciesList = () =>
    Object.keys(POLICIES).map((policy) => (
      <a
        className="hover-color"
        href={DOCUMENT_LINKS[policy]}
        target="_blank"
        rel="noreferrer"
        key={policy}
      >
        {POLICIES[policy]}
      </a>
    ));

  return (
    <StyledWrapper textAlignVal={textAlignVal}>
      <PoliciesList />
    </StyledWrapper>
  );
};

export default PolicyAndCharter;
